export const AUTH_TYPE = 'Bearer '
